<template>
    <PopupRouterView :showLeftIcon="true" label="Stock Opname Plan Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="stockopnameplan"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="stockOpnamePlanInput">


        <b-card header="Stock Opname Plan" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="STO Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   :isUpdatable ="null"/>
						<app-input-datepicker id="fieldset-start-stock-opname-period" label-cols-lg="12"  label="Start Stock Opname Period" size="sm" :model.sync="model.startStockOpnamePeriod"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :min="minDate"  :isUpdatable ="null"/>
						<!-- <app-input-datetimepicker id="fieldset-finish-stock-opname-period" label-cols-lg="12"  label="Finish Stock Opname Period" size="sm" :model.sync="model.finishStockOpnamePeriod"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable ="null"/> -->
						<!-- <app-input-combobox-autocomplete :options="stockOpnameStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Status" id="fieldset-stock-opname-status" size="sm" :model.sync="model.stockOpnameStatusId"   :selected="model.stockOpnameStatus != null ? model.stockOpnameStatus.name : ''" @input="getStockOpnameStatuss"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnameStatus" /> -->
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanList from '@/models/StockOpnamePlan/StockOpnamePlanList';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockOpnameStatus from '@/models/StockOpnameStatus/StockOpnameStatus';
import StockOpnameStatusFilter from '@/filters/StockOpnameStatus/StockOpnameStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputDatepicker from '@/components/AppInputDatepicker';
export default {
	components : {
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputComboboxAutocomplete,
		PopupRouterView,
		AppInputDatepicker,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "STO Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterStockOpnamePlan : null,
			currentStockOpnamePlanPage : 1,
			stockOpnamePlanPageSize: 10,
			sortByStockOpnamePlan: '',
			sortDescStockOpnamePlan: '',
			stockOpnameStatuss: [],
			stockOpnameStatuss: [],
			isStockOpnameStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStockOpnameStatusComboLoading: false,
			minDate : new Date(),
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getStockOpnamePlan : async function(id) {
			this.isBusy = true;
			StockOpnamePlan.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadStockOpnamePlan = true;
			this.filterStockOpnamePlan.id = this.modelId;
			StockOpnamePlan.downloadDataDetail(this, this.filterStockOpnamePlan).then(result => {
				this.isDownloadStockOpnamePlan = false;
			}).catch(error => { this.isDownloadStockOpnamePlan = false; })
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isStockOpnamePlanComboLoading = true;
			StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
				this.isStockOpnamePlanComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnameStatuss : async function(input) {
			let filter = new StockOpnameStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnameStatus(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnameStatusId = null;
				this.model.stockOpnameStatus = null;
			} else {
				this.model.stockOpnameStatusId = item.id;
				this.model.stockOpnameStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.stockOpnamePlanInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						StockOpnamePlan.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'stockopnameplanindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						StockOpnamePlan.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'stockopnameplanindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpnamePlan.updateData(this, model, id)
					.catch((error) => {
						this.getStockOpnamePlan(id);
					});
				}
			});
		},
		onHidden() {
			this.getStockOpnamePlans();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterStockOpnamePlan = new StockOpnamePlanFilter();
		//this.getStockOpnameStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getStockOpnamePlan(id);
			} else {
				this.modelId = id;
				this.getStockOpnamePlan(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
